import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi/*, putApi*/} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Emojis from './components/video/emojis';
import Chatbox from './components/messenger/chatbox';
import VideoPlayer from './components/video/video2';
import Genres from './components/genres/genres';
import Share from './components/share/share';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
//import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Badge from 'react-bootstrap/Badge';

import AdminOverlay from './components/admin/admin';

import './css/livechat.css';

export default class Live extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
		let channel = '';
		switch(true) {
			case /clubbers/i.test(window.location.pathname):
				channel = 'clubbers';
				break;
			case /radio/i.test(window.location.pathname):
				channel = 'radio';
				break;
			default:
				break;
		}
    this.state = {
			status: false,
			select: {
				select: 3,
				source: '/images/live/stream.jpg',
				width: 0,
			},
			select_temp: {
				select: 3,
				source: '/images/live/stream.jpg',
			},
			channel,

			prev: {},
			next: [],
			socials: {},
			users: [],
			showusers: false,
			//viewers: {online: 0, total: 0},

			meta: {
				azura: {connected: 0, dj: '', artist: '', title: '', art: '', time: 0, listeners: 0},
				rtmp: {connected: 0, path: this.channel, width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0, time: 0, listeners: 0}
			},

			stream: false,
			share: false,

			colorpalette: '#8c52ff',

			height: 500,
			theatre: false,

			HeaderMeta: null,
			ChatLiveVideo: null,
			IndexSchedule: null,
			ChatMeta: null,
			//VideoRate: null,

			//browser: '',

			Resize: null,

			name: '',
			email: '',
			artist: '',
			title: '',

			request: false,
			request_error: '',

			//videobitrate: {path: '', width: 0, height: 0, fps: 0, videorate: 0, audiorate: 0},
			resetvideo: false,

			emojiIcons: false,
			emojiIconsTimer: null,

			livetimestamp: '0:00:00',
			timeout: {},
			admin: false,
			admin_count: 1,
			adminListener: null,

			friend: false,

			affliiate: {},
			popup: {show: false, target: null},
		};
		this.videoComponent = React.createRef();

		this.handleChange = this.handleChange.bind(this);
		this.handleRequest = this.handleRequest.bind(this);
    this.renderLiveFeed = this.renderLiveFeed.bind(this);
		this.setColourpalette = this.setColourpalette.bind(this);
		this.onError = this.onError.bind(this);
		this.onAutoStart = this.onAutoStart.bind(this);
		this.reloadPlayer = this.reloadPlayer.bind(this);
		this.showusers = this.showusers.bind(this);
		this.theatre = this.theatre.bind(this);
		this.share = this.share.bind(this);
		this.admin = this.admin.bind(this);
		this.handlePopover = this.handlePopover.bind(this);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {

		/*
			Addresses:

			/clubbers
			/clubbers/????

		*/


		if( this.state.channel !== window.location.pathname.split('/')[1] ) {
			this.setState({status: false, channel: window.location.pathname.split('/')[1], select: {select: 3,source: '/images/live/stream.jpg',width: 0}, select_temp: {select: 3,source: '/images/live/stream.jpg',width: 0}},()=>{
				this.componentDidMount();
			});
		}
	}
  
  async componentDidMount() {
		document.title = "Chat / Live Video - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		var params = new URLSearchParams();
		params.append('channel', this.state.channel);
		const x = await postApi('/api/v2/livechat', params);
		this.renderLiveFeed(x.data.Live);
		this.setState({status: true, next: x.data.Next, meta: x.data.Meta, users: x.data.Users, socials: x.data.Socials, admin_count: x.data.Admin?x.data.Admin:0, affliiate: x.data.Affiliate});

		var video = document.getElementById("video");
		if(video) this.setState({height: Math.floor(video.offsetWidth/16*9)});


		//---- Video handler
		const ChatLiveVideo = EventEmitter.addListener(`/${this.state.channel}/channel`, async data => {
			this.renderLiveFeed( data.Live );
			this.setState({next: data.Next, socials: data.Socials});
		}); this.setState({ChatLiveVideo});

		//---- Whos on next
		/*const IndexSchedule = EventEmitter.addListener(`/${this.state.channel}/schedule`, async data => {
			this.setState({prev: data.Prev, next: data.Next});
		}); this.setState({IndexSchedule});*/

		//---- Viewers
		/*const ChatViewers = EventEmitter.addListener(`/${this.state.channel}/viewers`, async data => {
			this.setState({viewers: data});
		}); this.setState({ChatViewers});*/

		const ChatMeta = EventEmitter.addListener(`/${this.state.channel}/meta`, async data => {
			this.setState({meta: data});
		}); this.setState({ChatMeta});

		const adminListener = EventEmitter.addListener(`/admin/overlay`, async data => {
			this.setState({admin_count: data.count});
		}); this.setState({adminListener});

		//---- VideoRate
		/*const VideoRate = EventEmitter.addListener('/chatlive/videorate', async data => {
			this.setState({videobitrate: data});
		}); this.setState({VideoRate});*/

		//---- Page Resize
		/*
		const Resize = window.addEventListener('resize', () => {
			var video2 = document.getElementById("video");
			this.setState({height: Math.floor(video2.offsetWidth/16*9)});
		}); this.setState({Resize});
		*/

		//this.setState({browser: browserName});

		let y = document.getElementById("primary")
		if(y) y.click();

		this.setState({livetime: setInterval(()=>{
			if( this.state.meta.azura.time === 0 && this.state.meta.rtmp.time === 0 ) {
				this.setState({livetimestamp: `0:00:00`});
				return;
			}
			let time = Math.floor(Date.now()/1000-(this.state.meta.azura.time > this.state.meta.rtmp.time ? this.state.meta.azura.time : this.state.meta.rtmp.time));
			let h = Math.floor(time / 3600);
    	let m = Math.floor(time % 3600 / 60);
    	let s = Math.floor(time % 3600 % 60);
			this.setState({livetimestamp: `${h}:${m<10?'0'+m:m}:${s<10?'0'+s:s}`});
		}, 1000)});
		return ()=>{
			clearInterval(this.state.livetime);
		}
	}

	componentWillUnmount() {
		if( this.state.HeaderMeta ) this.state.HeaderMeta.remove();
		if( this.state.ChatLiveVideo ) this.state.ChatLiveVideo.remove();
		if( this.state.IndexSchedule ) this.state.IndexSchedule.remove();
		if( this.state.ChatMeta ) this.state.ChatMeta.remove();
		if( this.state.Resize ) this.state.Resize.remove();
		if( this.state.adminListener ) this.state.adminListener.remove();
		//if( this.state.VideoRate ) this.state.VideoRate.remove();
		clearTimeout(this.timeout);
		clearInterval(this.state.livetime);
		
	}


	async renderLiveFeed(feed) {
		//feed.select = 1;
		//console.log(feed);
		if( feed.select < 3 ) {
			if( Object.keys(feed.live).length>0 )
				if( window.location.pathname !== '/live/'+feed.live.username.toLowerCase().replaceAll(' ','') ) {
				}
			document.title = `${feed.live.djtitle?feed.live.djtitle:feed.live.username} ${feed.live.description?feed.live.description:''} Live - Mix365 Radio`;
			if( feed.live?.uid ) this.friend(feed.live.uid);
		} else {
			document.title = "Chat / Live Video - Mix365 Radio";
		}

		if( this.state.select.select === 1 && this.state.select_temp.select >= 3 && feed.select >= 3 ) {
			this.setState({select: feed, select_temp: feed},()=>{
				//let video2 = document.getElementById("video");
				//this.setState({height: Math.floor(video2.offsetWidth/16*9)});
			});
			return;
		}
		if( this.state.select.select === 1 && feed.select >= 3 ) {
			this.setState({select_temp: feed});
		} else {
			this.setState({select: feed, select_temp: feed},()=>{
				//let video2 = document.getElementById("video");
				//if( video2) this.setState({height: Math.floor(video2.offsetWidth/16*9)});
			});
		}
	}

	async setColourpalette(e) {
		this.setState({colorpalette: e.hex});
	}


	handleChange(event) {
		let item = event.target.value;
		if( event.target.name === "name" ) this.setState({name: item});
		if( event.target.name === "email" ) this.setState({email: item});
		if( event.target.name === "artist" ) this.setState({artist: item});
		if( event.target.name === "title" ) this.setState({title: item});
	}

	async handleRequest(event) {
		event.preventDefault();
		const user = this.context;
		let params = new URLSearchParams();
		params.append("channel", this.state.channel);
		if( user.user.user.id === 1 ) {
			if( this.state.name==='' ) { this.setState({request_error: '  * Please enter your name'}); return; }
			if( this.state.email==='' ) { this.setState({request_error: '  * Please enter your email address'}); return; }
			params.append("name", this.state.name);
			params.append("email", this.state.email);
		}
		if( this.state.artist==='' ) { this.setState({request_error: '  * Please enter song artist'}); return; }
		if( this.state.title==='' ) { this.setState({request_error: '  * Please enter song title'}); return; }
		params.append("artist", this.state.artist);
		params.append("title", this.state.title);
		await postApi('/api/v2/livechat/request', params);

		this.setState({request: true, name: '', email: '', artist: '', title: '', request_error: ''}, () => {
			setTimeout(() => {this.setState({request: false});}, 30000);
		});

	}

	onError(event) {
		if( this.state.select_temp.select >= 3 ) {
			this.setState({select: this.state.select_temp},()=>{
				var video2 = document.getElementById("video");
				this.setState({height: Math.floor(video2.offsetWidth/16*9)});
			});
		} else {
			/*let x = this.state.select;

			clearTimeout(this.timeout);

			this.timeout = setTimeout(() => {
				this.setState({select: {}}, () => {
					this.setState({select: x});
				})

			}, 3000);
			*/
			
		}
	}

	onAutoStart(event) {
		const player = window.jwplayer(this.playerId);
		player.play();
	}
	

	reloadPlayer() {
		
		if( this.state.resetvideo ) return;
		this.setState({resetvideo: true}, ()=>{

			setTimeout(()=>{
				if( this.state.select.select===3 ) return;

				let select = this.state.select;
				select.select = 3;
				this.setState({select, resetvideo: false}, ()=> {
					select.select = 1;
					this.setState({select});
				});
			},4000);
		});
	}

	extend(extend) {
		if( extend ) {
			this.setState({emojiIcons: true});
			clearInterval(this.state.emojiIconsTimer);
		} else {
			const x = setTimeout(()=>{
				this.setState({emojiIcons: false});
			}, 2500);
			this.setState({emojiIconsTimer: x});
			
		}
	}

	showusers() {
		this.setState({showusers: !this.state.showusers});
	}

	theatre() {
		this.setState({theatre: !this.state.theatre});
	}

	share(e) {
		this.setState({share: e.toLowerCase()});
	}
	close = (childData) => {
    this.setState({scheduleadd: false, scheduleedit: false, share: false});
	}

	admin() {
		this.setState({admin: !this.state.admin});
	}

	donation(uid) {
		EventEmitter.emit('/donation/donate', {uid});
	}

	pause() {
		//console.log("here!");
		//EventEmitter.emit('/header/audioplayer', {});
	}

	async friend(uid) {
		const params = new URLSearchParams();
		params.append( 'uid', uid );
    const x = await postApi('/api/v2/profile/isfriend', params);
		if( x.status === 200 ) {
			this.setState({friend: x.data.friend});
		}
	}

	async friends(uid, confirm = 0) {
		const params = new URLSearchParams();
		params.append( 'uid', uid );
		params.append( 'confirm', confirm );
    const x = await postApi('/api/v2/profile/friends', params);
		switch(x.status) {
			case 200:
				if( x.data.uid2 === this.state.select.live.uid ) {
					this.setState({friend: x.data.active===1?true:false});
				}
			break;
			case 218:
				if( window.confirm("Are you sure you wish to no longer follow this friend?") ) {
					await this.friends(uid, 1);
				}
			break;
			case 219:
				
			break;
			default:
			break;
		}
	}

	handlePopover(event) {
		this.setState({popup: {show: !this.state.popup.show, target: event.target}})
	}

	profileBlock() {
		const user = this.context;
		return (
			<>
				{this.state.select.select<=2?
					<Row className="px-4 py-4">
						<Col className="d-block d-lg-none livechat-follow-mobile text-center">
							<ButtonGroup size="sm" aria-label="Follow Share Donate" className="pb-1">
								{/*<Button variant="outline-primary"><FontAwesomeIcon icon="heart" /> Follow</Button>*/}
								{user.user?.admin?.part_admin_access &&
									<Button className="button-admin" onClick={()=>this.admin()}><FontAwesomeIcon icon="bars" /> Admin {this.state.admin_count>0?<><Badge bg="danger">{this.state.admin_count}</Badge></>:''}</Button>
								}
								{this.state.select.live.uid !== user.user?.user?.id &&
									<>
										<Button onClick={()=>this.friends(this.state.select.live.uid)}>{this.state.friend?<>Following <FontAwesomeIcon icon="check" /></>:<>Follow</>}</Button>
									</>
								}
								<Button onClick={()=>this.share(`/${this.state.channel}/${this.state.select.live.username.toLowerCase().replaceAll(' ','_')}`)}><FontAwesomeIcon icon="arrow-up-from-bracket" /> Share</Button>
								<Button onClick={()=>this.donation(this.state.select.live.uid)}><FontAwesomeIcon icon="donate" /> Donate</Button>
							</ButtonGroup>
							<br />
							<OverlayTrigger key="watching" placement="bottom" overlay={
									<Tooltip id="tooltip-watching">{this.state.meta.rtmp.listeners} Watching</Tooltip>
								}><span><FontAwesomeIcon icon="tv" />&nbsp;{this.state.meta.rtmp.listeners}</span>
							</OverlayTrigger>&nbsp;&nbsp;|&nbsp;&nbsp;
							<OverlayTrigger key="listening" placement="bottom" overlay={
									<Tooltip id="tooltip-replay">{this.state.meta.azura.listeners} Listening</Tooltip>
								}><span><FontAwesomeIcon icon="headphones" />&nbsp;{this.state.meta.azura.listeners}</span>
							</OverlayTrigger>&nbsp;&nbsp;|&nbsp;&nbsp;

							<OverlayTrigger key="streaming" placement="bottom" overlay={
									<Tooltip id="tooltip-streaming">Streaming Time</Tooltip>
								}><span><FontAwesomeIcon icon={['far', 'clock']} /> {this.state.livetimestamp}</span>
							</OverlayTrigger>
						</Col>
						<Col xs={12} lg={6}>
							<Row>
								<div style={{width: 90}} className="livechat-avatar-inner">
									{/*(this.state.meta.azura.art==='https://cloud.mix365.co.uk:4435/static/uploads/album_art.1676461238.png' )?
										<img src={`https://mix365.co.uk${this.state.select.live.avatar}`} alt="DJ Profile Avatar" />
									:*/}
										<img src={`https://mix365.co.uk${this.state.select.live.avatar}`} alt="DJ Profile Avatar" />
									
								</div>
								<Col>
									
									<span><strong>
										{moment(this.state.select.live.start*1000).format("HH:mm - ")}
										{moment(this.state.select.live.end*1000).format("HH:mm")}
									</strong></span>&nbsp;&nbsp;
									{this.state.select.live?.username&&
										<>
											<Link to={`/${this.state.select.live?.username.toLowerCase().replaceAll(' ','_')}`}>{this.state.select.live.title?this.state.select.live.title:this.state.select.live.djtitle?this.state.select.live.djtitle:this.state.select.live?.username}</Link><br />
										</>
									}
									{this.state.select.live.description&&<><FontAwesomeIcon icon="list" /> {this.state.select.live.description}<br /></>}
									{(this.state.meta.azura.artist!=='' && this.state.meta.azura.title!=='Live Broadcast')&&
										<Row className="gx-0 py-1">
											<div style={{width: 30}} className='text-vcenter'>
												<FontAwesomeIcon icon="music" />
											</div>
											<Col style={{height: this.state.meta.azura.title||this.state.meta.azura.artist?60:0}}>
												{this.state.meta.azura.artist&&this.state.meta.azura.artist.substring(0,40)}
												<br />
												<strong>
													{this.state.meta.azura.title&&this.state.meta.azura.title.substring(0,40)}
												</strong>
												<br />
												{this.state.meta.azura.label&&this.state.meta.azura.label.substring(0,40)}
											</Col>
										</Row>
									}
								</Col>
								
							</Row>
						</Col>
						<Col className="d-none d-lg-block text-right">
							<ButtonGroup size="sm" aria-label="Follow Share Donate" className="pb-1">
								{/*<Button variant="outline-primary"><FontAwesomeIcon icon="heart" /> Follow</Button>*/}
								{user.user?.admin?.part_admin_access &&
									<Button className="button-admin" onClick={()=>this.admin()}><FontAwesomeIcon icon="bars" /> Admin {this.state.admin_count>0?<><Badge bg="danger">{this.state.admin_count}</Badge></>:''}</Button>
								}
								{this.state.select.live.uid !== user.user?.user?.id &&
									<>
										<Button onClick={()=>this.friends(this.state.select.live.uid)}>{this.state.friend?<>Following <FontAwesomeIcon icon="check" /></>:<>Follow</>}</Button>
									</>
								}
								<Button onClick={()=>this.share(`/${this.state.channel}/${this.state.select.live.username.toLowerCase().replaceAll(' ','_')}`)}><FontAwesomeIcon icon="share" /> Share</Button>
								<Button onClick={()=>this.donation(this.state.select.live.uid)}><FontAwesomeIcon icon="donate" /> Donate</Button>
							</ButtonGroup>
							<br />
							<OverlayTrigger key="watching" placement="bottom" overlay={
									<Tooltip id="tooltip-watching">{this.state.meta.rtmp.listeners} Watching</Tooltip>
								}><span><FontAwesomeIcon icon="tv" />&nbsp;{this.state.meta.rtmp.listeners}</span>
							</OverlayTrigger>&nbsp;&nbsp;|&nbsp;&nbsp;
							<OverlayTrigger key="listening" placement="bottom" overlay={
									<Tooltip id="tooltip-replay">{this.state.meta.azura.listeners} Listening</Tooltip>
								}><span><FontAwesomeIcon icon="headphones" />&nbsp;{this.state.meta.azura.listeners}</span>
							</OverlayTrigger>&nbsp;&nbsp;|&nbsp;&nbsp;

							<OverlayTrigger key="streaming" placement="bottom" overlay={
									<Tooltip id="tooltip-streaming">Streaming Time</Tooltip>
								}><span><FontAwesomeIcon icon={['far', 'clock']} /> {this.state.livetimestamp}</span>
							</OverlayTrigger>

							
						</Col>
						<Col xs={12}>
							<Genres genres={this.state.select.live.genres} />
						</Col>

					</Row>
				:
					<Row className="px-2 py-4">
						<Col>
							<Row>
								<div style={{width: 90}} className="livechat-avatar-inner">
									<img src={this.state.meta.azura.art.length>0?this.state.meta.azura.art:"https://mix365.co.uk/images/user.png"} alt="DJ Profile Avatar" />
								</div>
								<Col>
									<Link to='#'>Auto DJ</Link><br />
									{this.state.meta.azura.artist&&
										<span style={{fontSize: 14}}>
											Artist: {this.state.meta.azura.artist}<br/>
											Title: {this.state.meta.azura.title}
										</span>
									}<br />
								</Col>
							</Row>
						</Col>
						<Col className="text-right">
							<ButtonGroup size="sm" aria-label="Follow Share Donate" className="pb-1">
								{/*<Button variant="outline-primary"><FontAwesomeIcon icon="heart" /> Follow</Button>*/}
								{user.user?.admin?.part_admin_access &&
									<>
										{/*<Overlay
											show={this.state.popup.show}
											target={this.state.popup.target}
											placement="top"
											containerPadding={20}
										>
											<Popover id="popover-contained">
												<Popover.Header as="h3">Enjoying listening to this DJ?<span className="float-right" onClick={this.handlePopover}><FontAwesomeIcon icon="times" /></span></Popover.Header>
												<Popover.Body>
													Why not follow and receive notifications when they go live.
												</Popover.Body>
												<Popover.Header as="h3">Donate<span className="float-right" onClick={this.handlePopover}><FontAwesomeIcon icon="times" /></span></Popover.Header>
												<Popover.Body>
													You can now donate directly to the DJ to say thank you.
												</Popover.Body>
											</Popover>
										</Overlay>
										<Button onClick={this.handlePopover}>Test</Button>*/}
										<Button className="button-admin" onClick={()=>this.admin()}><FontAwesomeIcon icon="bars" /> Admin {this.state.admin_count>0?<><Badge bg="danger">{this.state.admin_count}</Badge></>:''}</Button>
										{/*<Button onClick={()=>this.pause()}><FontAwesomeIcon icon="bars" /> Pause</Button>*/}
									</>
								}
								<Button onClick={()=>this.share(`/clubbers`)}><FontAwesomeIcon icon="arrow-up-from-bracket" /> Share</Button>
								<Button onClick={()=>this.donation(0)}><FontAwesomeIcon icon="donate" /> Donate</Button>
							</ButtonGroup>
							<br />
							<OverlayTrigger key="listening" placement="bottom" overlay={
									<Tooltip id="tooltip-replay">{this.state.meta.azura.listeners} Listening</Tooltip>
								}><span><FontAwesomeIcon icon="headphones" />&nbsp;{this.state.meta.azura.listeners}</span>
							</OverlayTrigger>&nbsp;&nbsp;

						</Col>
					</Row>
				}
			</>
		)
	}
	

	render() {
		const user = this.context;
		const next = this.state.next.map((e,i) => {
			return (
				<Row key={i} className="gx-0 mix365djs-about-box">
					<div style={{width: 60}} className="text-center">
						<img src={`https://mix365.co.uk${this.state.next[i].avatar}`} width="48" height="48" />
					</div>
					<Col className="text-vertical text-left">
						<div>
							<span style={{fontSize: 16}}>
								{moment(this.state.next[i].start*1000).format("HH:mm - ")}
								{moment(this.state.next[i].end*1000).format("HH:mm")}
								{(this.state.select.select<=2 && this.state.select.live.id===this.state.next[i].id ) &&
									<>&nbsp;<span style={{backgroundColor: '#ff0000', fontSize: 14, padding: '0px 6px'}}>Live</span></>
								}
							</span>&nbsp;&nbsp;
							<Link to={`/${this.state.next[i].username.replaceAll(' ','_')}`}>{this.state.next[i].djtitle?this.state.next[i].djtitle:this.state.next[i].title?this.state.next[i].title:this.state.next[i].username}</Link><br />
							
							<span style={{fontSize: 14}}>
								{this.state.next[i].description&&<><FontAwesomeIcon icon="list" /> {this.state.next[i].description}<br /></>}
								
							</span>
							
						</div>
						
					</Col>
					<div style={{width: 100}}>
						<div className="text-vright me-2"><Button size="sm" onClick={()=>this.share(`/${this.state.channel}/${this.state.next[i].username.toLowerCase().replaceAll(' ','_')}`)} style={{border: 'none'}}><FontAwesomeIcon icon="share" /></Button></div>
					</div>
				</Row>
			)
		})
		return (
			<>
				{this.state.status &&
					<>
						<div className="live">
							<div className="live-background"></div>
						</div>
						
						
							
						<div className="article">
							<Row className="gx-0 pb-5">
								{/*<Col xs={6} className="live-header">
									<h3></h3>
								</Col>*/}
								{this.state.channel === 'clubbers' &&
									<Col className="live-header">
										<img src="/images/channel_clubbers.png" width="30%" alt={`Mix365 ${this.state.channel}`} />
									</Col>
								}
								{this.state.channel === 'radio' &&
									<Col className="live-header">
										<img src="/images/channel_radio.png" width="30%" alt={`Mix365 ${this.state.channel}`} />
									</Col>
								}
							</Row>
								
								<Row>
									<Col className="text-center">
										
									</Col>
								</Row>
								<Row>
									<Col>

										<div className={`livechat ${this.state.theatre&&'livechat-theatre'}`}>


											<div className="livechat-videoposter">

												{this.state.select.select===1?
													<VideoPlayer
														id="video"
														url={this.state.channel} //{this.state.select.address}
														//select={this.state.select_temp.select}
														uid={this.state.select.live?.uid}
														theatre={this.theatre}
														onError={this.onError}
														height={this.state.meta.video.height}
													/>
												:
													<>
														{this.state.select.poster.display.sourceobject ?
															<img id="video" src={`data:image/png;base64,${this.state.select.poster.display.sourceobject}`} style={{width:'100%'}} alt="Live Poster" />
														:
															<div onMouseEnter={()=>this.extend(true)} onMouseLeave={()=>this.extend(false)}>
																<img id="video" src={`https://mix365.co.uk${this.state.select.poster.display.source}`} style={{width:'100%'}} alt="Live Poster" />
																{/*<Emojis showIcons={this.state.emojiIcons} />*/}
															</div>
														}
													</>
												}

												{this.state.admin ?
													<AdminOverlay live={this.state.select.live} close={this.admin} />
												:
													<Emojis showIcons={this.state.select.select<=2?true:false} channel={this.state.channel} />
												}
												{this.state.theatre&&<>{this.profileBlock()}</>}
											</div>
											<div className="livechat-chatbox">

												<Chatbox
													type={this.state.channel}
													colour={this.state.colorpalette}
													newColour={this.setColourpalette}
													theatre={this.theatre}
												/>
											</div>

										</div>


									</Col>
								</Row>
								
								<div className="livechat-profile">
									<Row className={`gx-0 livechat-profile-${this.state.channel}`}>
										<Col xs={12} md={9}>
											{this.profileBlock()}
										</Col>
										<Col xs={12} md={3} className="livechat-profile-rules text-vcenter">
											<div>
												<strong>Mix365 Chat Rules:</strong><br />
												1. No Foul Language<br />
												2. No Obscenity Pics / Websites<br />
												3. Respect other Listeners and Staff<br />
												Any Rules Broken and You Will Be Banned
											</div>
										</Col>
									</Row>
								</div>
							</div>

							<div className="article pt-5">
								
								<Row>
									<Col xs={12} md={4}>
										<div className="mix365djs-card">
											<Row className="gx-0 mix365djs-description text-center">
												<Col xs={12} className="p-2">
													{this.state.channel.charAt(0).toUpperCase()}{this.state.channel.slice(1)} Schedule
												</Col>
											</Row>
											{next}
										</div>
									</Col>
									{this.state.select.select<=2&&
									<>
									<Col xs={12} md={4}>
										<div className="mix365djs-card">
											<Row className="gx-0 mix365djs-description">
												<Col xs={5} md={4}>
													<div className="mix365djs-avatar" style={{position: 'relative'}}>
														{this.state.select.live?.username&&
															<Link to={`/${this.state.select.live.username.replaceAll(' ','_')}`}>
																<img src={`https://mix365.co.uk/${this.state.select.live.avatar}`} alt="DJ Profile Avatar" className="mix365djs-avatar-img" width="100%" />
															</Link>
														}
													</div>
												</Col>
												<Col className="text-vcenter">
													<Row className="gx-0">
														<Col xs={12}>
															{this.state.select.live?.username&&
																<Link to={`/${this.state.select.live.username.replaceAll(' ','_')}`}>
																	{this.state.select.live.title?this.state.select.live.title:this.state.select.live.djtitle?this.state.select.live.djtitle:this.state.select.live.username}
																</Link>
															}<br />
														</Col>
														{/*<Col xs={12} className="profile-country">
															{user.user?.access?.level>=20&&this.state.djs[e].country_default.length>0&&
																<><FontAwesomeIcon icon="location-dot" /> {this.state.djs[e].country_default.replace('/',', ')}<br /></>
															}
															<FontAwesomeIcon icon={['far', 'clock']} /> Joined {moment(this.state.djs[e].joined*1000).format("Do MMMM YYYY")}
														</Col>*/}
										
														<Col xs={12}>
															<ul className="mix365djs-socials">
																{this.state.socials.facebook &&
																	<li>
																		<a href={this.state.socials.facebook} title="Facebook" target="_blank" rel="noreferrer">
																			<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
																		</a>
																	</li>
																}
																{/*<li>H</li>*/}
																{this.state.socials.instagram &&
																	<li>
																		<a href={this.state.socials.instagram} title="Instagram" target="_blank" rel="noreferrer">
																			<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
																		</a>
																	</li>
																}
																{this.state.socials.mixcloud &&
																	<li>
																		<a href={this.state.socials.mixcloud} title="Mixcloud" target="_blank" rel="noreferrer">
																			<FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" />
																		</a>
																	</li>
																}
																{this.state.socials.soundcloud &&
																	<li>
																		<a href={this.state.socials.soundcloud} title="Soundcloud" target="_blank" rel="noreferrer">
																			<FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" />
																		</a>
																	</li>
																}
																{this.state.socials.twitch &&
																	<li>
																		<a href={this.state.socials.twitch} title="Twitch" target="_blank" rel="noreferrer">
																			<FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" />
																		</a>
																	</li>
																}
																{this.state.socials.youtube &&
																	<li>
																		<a href={this.state.socials.youtube} title="Youtube" target="_blank" rel="noreferrer">
																			<FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" />
																		</a>
																	</li>
																}
																{Object.keys(this.state.socials).length<=5&&
																	<li>
																		No socials available for this DJ.
																	</li>
																}
															</ul>
														</Col>
													</Row>
												</Col>
											</Row>
											<Row className="gx-0 mix365djs-about-box">
												<Col>
													<OverlayTrigger key="performances" placement="bottom" overlay={
															<Tooltip id="tooltip-performances">{this.state.socials.performances} Performances</Tooltip>
														}><span style={{fontSize:12}}><FontAwesomeIcon icon="compact-disc" style={{fontSize:14}} /> {this.state.socials.performances}</span>
													</OverlayTrigger>
												</Col>
												<Col>
													<OverlayTrigger key="plays" placement="bottom" overlay={
															<Tooltip id="tooltip-plays">{this.state.socials.listeners} Plays</Tooltip>
														}><span style={{fontSize:12}}><FontAwesomeIcon icon="play" style={{fontSize:14}} /> {this.state.socials.listeners}</span>
													</OverlayTrigger>
												</Col>
												<Col>
													<OverlayTrigger key="favorites" placement="bottom" overlay={
															<Tooltip id="tooltip-favorites">{this.state.socials.favorites} Favorites</Tooltip>
														}><span style={{fontSize:12}}><FontAwesomeIcon icon="heart" style={{fontSize:14}} /> {this.state.socials.favorites}</span>
													</OverlayTrigger>
												</Col>
												<Col>
													<OverlayTrigger key="likes" placement="bottom" overlay={
															<Tooltip id="tooltip-likes">{this.state.socials.likes} Likes</Tooltip>
														}><span style={{fontSize:12}}><FontAwesomeIcon icon="thumbs-up" style={{fontSize:14}} /> {this.state.socials.likes}</span>
													</OverlayTrigger>
												</Col>
												<Col>
													<OverlayTrigger key="hours" placement="bottom" overlay={
															<Tooltip id="tooltip-hours">{this.state.socials.hours} Hours</Tooltip>
														}><span style={{fontSize:12}}><FontAwesomeIcon icon="hourglass-empty" style={{fontSize:14}} /> {this.state.socials.hours}</span>
													</OverlayTrigger>
												</Col>
											</Row>
											<Row className="mix365djs-bottom gx-0">
												<Col className="mix365djs-biography">
													{this.state.select.live.country&&<><FontAwesomeIcon icon="globe-europe" /> {this.state.select.live.country.replaceAll('/',', ')}<br /></>}
												</Col>
											</Row>
										</div>
										
									</Col>
									<Col xs={12} md={4}>
										<div className="mix365djs-card">
											<Row className="gx-0 mix365djs-description text-center">
												<Col xs={12} className="p-2">
													Song Request
												</Col>
											</Row>
											<Row className="gx-0 mix365djs-about-box">
												<Col className="text-vertical text-left">
													<Form className="pagelayer-contact-form" id="contact-form" onSubmit={this.handleRequest}>
														
														{user.user.user?.id === 1 &&
															<>
																<label>Your Name:</label>
																<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																	<FormControl type="text" name="name" id="name" onChange={this.handleChange} value={this.state.name} aria-label="Name" aria-describedby="basic-addon1" required />
																</InputGroup>
															</>
														}
													
														
														<InputGroup className="row" style={{paddingBottom: '0px'}}>
															<Col md={4} className="text-vcenter">
																<label htmlFor="artist">Artist:</label>
															</Col>
															<FormControl className="col-md-6" type="text" name="artist" id="artist" onChange={this.handleChange} value={this.state.artist} aria-label="Artist" aria-describedby="basic-addon1" required />
														</InputGroup>
													
														
														<InputGroup className="row" style={{paddingBottom: '0px'}}>
															<Col md={4} className="text-vcenter">
																<label htmlFor="title">Song:</label>
															</Col>
															<FormControl className="col-md-6" type="text" name="title" id="title" onChange={this.handleChange} value={this.state.title} aria-label="Title" aria-describedby="basic-addon1" required />
														</InputGroup>
														
														<Row className="gx-0">
															<Col md={4}>
															</Col>
															<Col md={6} className="pt-2">
																<Button size="sm" onClick={this.handleRequest}>Request</Button>
																<OverlayTrigger
																	trigger="click"
																	key="right"
																	placement="right"
																	show={this.state.request}
																	overlay={
																		<Popover id={`popover-positioned-right`}>
																			<Popover.Header as="h3">Thank you</Popover.Header>
																			<Popover.Body>
																				Your song request has been submitted
																			</Popover.Body>
																		</Popover>
																	}
																>
																	<span>{this.state.request_error}</span>
																</OverlayTrigger>
															</Col>
														</Row>
													</Form><br />
												</Col>
											</Row>
										</div>
									</Col>
									</>
									}
								</Row>
								
							</div>
							{Object.values(this.state.affliiate).length > 0 &&
								<div className="affiliates">
									<div className="text-center">
										<a href={this.state.affliiate.url} alt="affiliates" target="_blank" rel="noreferrer">
											<img src={`https://mix365.co.uk${this.state.affliiate.image}`} />
										</a>
									</div>
								</div>
							}
							
								{/*<div className="article">
									<Row>
										<Col>
												<div className="row px-0 mx-0 text-white">
													<div className="col-12 col-lg-11 mx-auto">
														<div className="row">
															<div className="col-12 col-lg-9">

																

																{this.state.select?.select < 3 && user.user.user?.id === 1 &&
																	<div className="col-12" style={{marginTop: '50px'}}>
																		<div className="profile-heading livechat-now">
																			Song Request
																		</div>
																		<div className="row">
																			<div className="col">
																				<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
																					<div className="pagelayer-contact-form-div pagelayer-contact-form-holder">
																						<Form className="pagelayer-contact-form" id="contact-form" onSubmit={this.handleRequest}>
																							<div className="pagelayer-contact-holder">
																								<div className="row">
																									<div className="col-6 col-md-4 p-2">
																										<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																											<FormControl type="text" name="name" id="name" onChange={this.handleChange} value={this.state.name} placeholder="Name" aria-label="Name" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
																										</InputGroup>
																									</div>
																									<div className="col-6 col-md-4 p-2">
																										<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																											<FormControl type="email" name="email" id="email" onChange={this.handleChange} value={this.state.email} placeholder="Email" aria-label="Email" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
																										</InputGroup>
																									</div>
																								</div>
																								<div className="row">
																									<div className="col-6 col-md-4 p-2">
																										<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																											<FormControl type="text" name="artist" id="artist" onChange={this.handleChange} value={this.state.artist} placeholder="Artist" aria-label="Artist" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
																										</InputGroup>
																									</div>
																									<div className="col-6 col-md-4 p-2">
																										<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																											<FormControl type="text" name="title" id="title" onChange={this.handleChange} value={this.state.title} placeholder="Title" aria-label="Title" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
																										</InputGroup>
																									</div>
																								</div>
																							</div>
																							<div className="pagelayer-contact-submit-holder">
																								<button onClick={this.handleRequest} className="pagelayer-contact-submit-btn pagelayer-btn-holder pagelayer-ele-link pagelayer-btn-custom pagelayer-btn-mini {{icon_position}}">
																									<span className="pagelayer-btn-text">Request</span>
																								</button>
																								<OverlayTrigger
																									trigger="click"
																									key="right"
																									placement="right"
																									show={this.state.request}
																									overlay={
																										<Popover id={`popover-positioned-right`}>
																											<Popover.Header as="h3">Thank you</Popover.Header>
																											<Popover.Body>
																												Your song request has been submitted
																											</Popover.Body>
																										</Popover>
																									}
																								>
																									<span>{this.state.request_error}</span>
																								</OverlayTrigger>
																							</div>
																						</Form>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																}

																{this.state.select?.select < 3 && user.user.user?.id >= 2 &&
																	<div className="col-12" style={{marginTop: '50px'}}>
																		<div className="profile-heading livechat-now">
																			Song Request
																		</div>
																		<div className="row">
																			<div className="col">
																				<div pagelayer-id="pxc9717" className="p-pxc9717 pagelayer-contact fadeInUp pagelayer-wow pagelayer-anim-slowest">
																					<div className="pagelayer-contact-form-div pagelayer-contact-form-holder">
																						<Form className="pagelayer-contact-form" id="contact-form" onSubmit={this.handleRequest}>
																							<div className="pagelayer-contact-holder">
																								<div className="row">
																									<div className="col-6 col-md-4 p-2">
																										<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																											<FormControl type="text" name="artist" id="artist" onChange={this.handleChange} value={this.state.artist} placeholder="Artist" aria-label="Artist" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
																										</InputGroup>
																									</div>
																									<div className="col-6 col-md-4 p-2">
																										<InputGroup className="p-aav3421 pagelayer-contact_item" style={{paddingBottom: '0px'}}>
																											<FormControl type="text" name="title" id="title" onChange={this.handleChange} value={this.state.title} placeholder="Title" aria-label="Title" aria-describedby="basic-addon1" required style={{padding: '5px 10px'}} />
																										</InputGroup>
																									</div>
																								</div>
																							</div>
																							<div className="pagelayer-contact-submit-holder">
																								<button onClick={this.handleRequest} className="pagelayer-contact-submit-btn pagelayer-btn-holder pagelayer-ele-link pagelayer-btn-custom pagelayer-btn-mini {{icon_position}}">
																									<span className="pagelayer-btn-text">Request</span>
																								</button>
																								<OverlayTrigger
																									trigger="click"
																									key="right"
																									placement="right"
																									show={this.state.request}
																									overlay={
																										<Popover id={`popover-positioned-right`}>
																											<Popover.Header as="h3">Thank you</Popover.Header>
																											<Popover.Body>
																												Your song request has been submitted
																											</Popover.Body>
																										</Popover>
																									}
																								>
																									<span>{this.state.request_error}</span>
																								</OverlayTrigger>
																							</div>
																						</Form>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																}
															</div>
														</div>
													</div>
												</div>
										</Col>
									</Row>
								</div>*/}
						
					</>
				}
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}
